import { MAXIMUM_LIMIT_MESSAGE } from 'src/compass/shared/schemas/getStringSchema';
import { getMaximumDecimalSchema, getPercentSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

// ----------------------------------------------------------------------
// #TODO:- Will update below line
const VALID_NUMBER = 'Please enter valid number';

export const AdditSchema = Yup.object().shape({
  description: Yup.string()
    .max(50, MAXIMUM_LIMIT_MESSAGE)
    .nullable()
    .required('Description is required'),
  glAccountInfo: Yup.string().max(50, MAXIMUM_LIMIT_MESSAGE),
  payrollExportCode: Yup.string().max(50, MAXIMUM_LIMIT_MESSAGE).nullable(),
  isActive: Yup.boolean().oneOf([true, false], 'Active is required').default(true),
  asOf: Yup.object({
    rateType: Yup.string()
      .required('A rate type selection is required.')
      .oneOf(['ratePerHead', 'ratePercent'], 'A rate type selection is required.'),
    ratePerHead: Yup.number()
      .concat(getMaximumDecimalSchema())
      .typeError(VALID_NUMBER)
      .when('rateType', (rateType: any, schema) => {
        if (rateType?.[0] === 'ratePerHead') {
          return schema
            .test(
              'isNumber',
              'Rate per head must be a number',
              (value) => typeof value === 'number'
            )
            .required('Rate must be greater than $0.')
            .moreThan(0, 'Rate must be greater than $0.');
        }
        return schema.transform(() => 0).default(0);
      }),
    ratePercent: Yup.number()
      .typeError(VALID_NUMBER)
      .when('rateType', (rateType: any, schema) => {
        if (rateType?.[0] === 'ratePercent') {
          return getPercentSchema('Rate', 100, 2);
        }
        return schema.transform(() => 0).default(0);
      }),
    only12Months: Yup.boolean().oneOf([true, false], 'Only 12 months is required').default(false),
  }),
});

export const AcceleratedSchema = Yup.object().shape({
  employeeId: Yup.mixed<any>().required('Agent is required'),
  monthYear: Yup.mixed<any>().required('Month/Year is required.'),
  percent: Yup.number()
    .integer('Percent must not be decimal.')
    .typeError(VALID_NUMBER)
    .required('Percent must be greater than 0%.')
    .moreThan(0, 'Percent must be greater than 0%.')
    .max(100, 'Percent must not be more than 100%.'),
});
